import { Fragment } from 'react';

import {
  ActivityChangeOptions,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';

export interface FlagsModuleData {
  targetingKeySelector?: string;
  stickyAssignments?: boolean;
  ignoreTargetingForSticky?: boolean;
  [key: string]: unknown;
}

const formatEnabled = (value: boolean | undefined): string => {
  if (value === undefined) return 'Not set';
  return value ? 'Enabled' : 'Disabled';
};

const formatRandomizationUnit = (value: string | undefined): string => {
  if (!value) return 'Not set';
  const parts = value.split('/');
  return parts[parts.length - 1];
};

export const AudienceFlagsRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as FlagsModuleData | null;
  const newValue = change.newValue as FlagsModuleData | null;

  return (
    <Fragment>
      {oldValue?.targetingKeySelector !== newValue?.targetingKeySelector && (
        <ActivityTagItem
          tagLabel="Randomization unit"
          oldValue={formatRandomizationUnit(oldValue?.targetingKeySelector)}
          newValue={formatRandomizationUnit(newValue?.targetingKeySelector)}
        />
      )}
      {oldValue?.stickyAssignments !== newValue?.stickyAssignments && (
        <ActivityTagItem
          tagLabel="Sticky assignments"
          oldValue={formatEnabled(oldValue?.stickyAssignments)}
          newValue={formatEnabled(newValue?.stickyAssignments)}
        />
      )}
      {oldValue?.ignoreTargetingForSticky !==
        newValue?.ignoreTargetingForSticky && (
        <ActivityTagItem
          tagLabel="Don't enforce inclusion criteria"
          oldValue={formatEnabled(oldValue?.ignoreTargetingForSticky)}
          newValue={formatEnabled(newValue?.ignoreTargetingForSticky)}
        />
      )}
    </Fragment>
  );
};
